import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { ANGULAR_MODULES } from '../Shared/shared-imports';
import { MenuSelectionService } from '../services/MenuSelectionService.service';
import { PosSettingsService } from '../services/pos-settings.service';
import { lastValueFrom, take } from 'rxjs';
import { GeneralService } from '../services/general.service';
import { UserService } from '../services/User.service';
import { ToastrService } from 'ngx-toastr';
import { SharedHTMLSettingsDataService } from '../Shared/sharedHTMLSettingsData.service';

@Component({
  selector: 'app-point-of-sales',
  standalone: true,
  imports: [ANGULAR_MODULES],
  templateUrl: './point-of-sales.html',
  styleUrl: './point-of-sales.scss'
})
export class PointOfSales implements OnInit{
  constructor(private menuService: MenuSelectionService,private router: Router,
    private posSettingsService: PosSettingsService,
    private generalService: GeneralService,
    private userService: UserService,
    private toastr: ToastrService,
    private sharedHTMLSettings: SharedHTMLSettingsDataService
  ) {}

  selectedMenu = '1';
  setUserTerminalId = '0';
  allowRetail = false;
  allowWholeSale = false;
  allowShipped = false;
  allowLayaway = false;
  allowPending = false;
  allowReturn = false;
  allowVoid = false;
  defaultSaleType = 1;
  userSaleTypePermission;
  @Input() isCollapsed: boolean = false;

  ngOnInit(): void {
    this.getDefaultTerminalId();
    this.menuService.selectedMenu$.subscribe(menu => {
        this.selectedMenu = menu.toString();
      });   
      this.getUserAllowedPosSales();
  }

  async getUserAllowedPosSales() {
    this.generalService.UserPermissions = await lastValueFrom(
      this.generalService.GetUserPermission().pipe(take(1))
    );
    this.userSaleTypePermission = this.generalService.getUserSaleTypes();
    this.getPosSettings();
  }

  getDefaultTerminalId() {
    this.userService.getDefaultTerminalId()
      .pipe(take(1))
      .subscribe(res => {
        if (res && res != 0) {
          this.generalService.setTerminal(res);
        }else{
            this.toastr.info($localize`User Default Terminal Not Set`, $localize`Info`, this.sharedHTMLSettings.ToasterConfig);
        }
      })
  }

  getPosSettings() {
    this.posSettingsService.getPosSettings()
      .pipe(take(1))
      .subscribe(res => {
        if (res) {
          this.allowRetail = res.SalesTypesSettings.AllowRetail && this.userSaleTypePermission.find(x => x.SalesTypeID == 1).SalesTypeAllowed;
          this.allowWholeSale = res.SalesTypesSettings.AllowWholeSale && this.userSaleTypePermission.find(x => x.SalesTypeID == 2).SalesTypeAllowed;
          this.allowShipped = res.SalesTypesSettings.AllowShipped && this.userSaleTypePermission.find(x => x.SalesTypeID == 3).SalesTypeAllowed;
          this.allowLayaway = res.SalesTypesSettings.AllowLayaway && this.userSaleTypePermission.find(x => x.SalesTypeID == 5).SalesTypeAllowed;
          this.allowPending = res.SalesTypesSettings.AllowPending && this.userSaleTypePermission.find(x => x.SalesTypeID == 6).SalesTypeAllowed;
          this.allowReturn = res.SalesTypesSettings.AllowReturn && this.userSaleTypePermission.find(x => x.SalesTypeID == 7).SalesTypeAllowed;
          this.allowVoid = res.SalesTypesSettings.AllowVoid && this.userSaleTypePermission.find(x => x.SalesTypeID == 8).SalesTypeAllowed;
          if (this.defaultSaleType == 1 && this.selectedMenu == '1') { //To avoid value change when the menu is changed
            this.defaultSaleType = res.SalesTypesSettings.DefaultSaleType;
            if (res.SalesTypesSettings.DefaultSaleType) {
              this.menuService.setMenu(this.defaultSaleType.toString());
            }
          }
        }
      });
  }

  ngOnChanges(changes: SimpleChanges) {
    // if (changes['isCollapsed']) {
    //   const sidebar = document.getElementById('sidebar');
    //   if (sidebar) {
    //     sidebar.classList.toggle('collapsed', this.isCollapsed);
    //   }
    // }
  }
  
  onMenuChange(value: string) {
    this.selectedMenu = value;
    this.menuService.setMenu(value);
  }
}
